import type { PopoverProps } from "react-aria-components";

import type { ReactNode } from "react";

import type { ButtonProps } from "../button";

import { useState } from "react";

import clsx from "clsx";
import { Menu as AriaMenu, MenuTrigger, Popover } from "react-aria-components";

import { Button } from "../button";

import styles from "./menu.module.css";

type MenuProps = ButtonProps & {
	children: ReactNode;
	dropdownPlacement?: PopoverProps["placement"];
	menuIcon: ReactNode;
	variant?: ButtonProps["variant"];
};

export function Menu({
	children,
	dropdownPlacement = "bottom right",
	menuIcon,
	variant = "secondary",
	...props
}: MenuProps): ReactNode {
	const [isOpen, setIsOpen] = useState(false);
	return (
		<MenuTrigger data-testid="menu" isOpen={isOpen} onOpenChange={setIsOpen}>
			<Button
				className={clsx(isOpen && styles.activeBtn)}
				iconOnly
				size="sm"
				variant={variant}
				{...props}
			>
				{menuIcon}
			</Button>
			<Popover className={styles.dropdown} placement={dropdownPlacement}>
				<AriaMenu>{children}</AriaMenu>
			</Popover>
		</MenuTrigger>
	);
}
